export enum ColumnFilterOperator {
    EQUALS = "EQUALS",
    EMPTY = "EMPTY",
    CONTAINS = "CONTAINS",
    PREFIX = "PREFIX",
    SUFFIX = "SUFFIX"
}
